import { render } from "./stats-card.vue?vue&type=template&id=0d85dfd0&lang=pug"
import script from "./stats-card.vue?vue&type=script&lang=js"
export * from "./stats-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__